import { Component } from "@/commons/interface/building/component";
import { StdResponse, bimAxios } from "@/config/axios"

export function findComponentByType(type: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/components/${type}`, {
        params: {
            ...params,
        }
    })
}
// 查找含有name字段的组件
export function findComponentList(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/components`, {
        params: {
            ...params,
        }
    })
}

// 查找含有name字段的组件
export function addComponent(data: Component, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/components`, data, {
        params: {
            ...params,
        }
    })
}